import React from "react"

export default function EmptyStateBlock({
  title = "Sin información",
  text = "",
  compact = false
}) {
  return (
    <div
      style={{
        border: "1px dashed #cbd5e1",
        background: "#f8fafc",
        borderRadius: 14,
        padding: compact ? 12 : 16,
        color: "#475569"
      }}
    >
      <div
        style={{
          fontWeight: 900,
          color: "#0f172a",
          fontSize: compact ? 13 : 14,
          marginBottom: text ? 4 : 0
        }}
      >
        {title}
      </div>

      {text ? (
        <div
          style={{
            fontSize: 12.5,
            lineHeight: 1.45
          }}
        >
          {text}
        </div>
      ) : null}
    </div>
  )
}
